/* Neko Neko Store — interacciones. Sin librerías externas. */
(function () {
  'use strict';

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ----------------------------------------------------------------------
     Animaciones de entrada al hacer scroll (un solo observer compartido)
     ---------------------------------------------------------------------- */
  function initReveals(root) {
    var items = (root || document).querySelectorAll('.nk-reveal:not(.nk-visible)');
    if (!items.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('nk-visible');
      });
      return;
    }

    if (!window.__nkObserver) {
      window.__nkObserver = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('nk-visible');
            obs.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );
    }

    items.forEach(function (el) {
      window.__nkObserver.observe(el);
    });
  }

  /* ----------------------------------------------------------------------
     Galería de producto: miniatura -> imagen principal
     ---------------------------------------------------------------------- */
  function initGaleria(root) {
    var galerias = (root || document).querySelectorAll('[data-nk-galeria]');
    if (!galerias.length) return;

    galerias.forEach(function (galeria) {
      if (galeria.dataset.nkListo === '1') return;
      galeria.dataset.nkListo = '1';

      var principal = galeria.querySelector('[data-nk-galeria-principal]');
      var minis = galeria.querySelectorAll('[data-nk-galeria-mini]');
      if (!principal || !minis.length) return;

      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var src = mini.getAttribute('data-src');
          var alt = mini.getAttribute('data-alt') || '';
          if (!src) return;
          principal.src = src;
          principal.alt = alt;
          minis.forEach(function (m) {
            m.classList.remove('nk-activa');
          });
          mini.classList.add('nk-activa');
        });
      });
    });
  }

  /* ----------------------------------------------------------------------
     Selector de variantes: opciones -> variante -> precio + input del form
     ---------------------------------------------------------------------- */
  function initVariantes(root) {
    var formas = (root || document).querySelectorAll('[data-nk-producto]');
    if (!formas.length) return;

    formas.forEach(function (bloque) {
      if (bloque.dataset.nkListo === '1') return;
      bloque.dataset.nkListo = '1';

      var datos = bloque.querySelector('[data-nk-variantes]');
      if (!datos) return;

      var variantes;
      try {
        variantes = JSON.parse(datos.textContent);
      } catch (e) {
        return;
      }
      if (!variantes || !variantes.length) return;

      var inputId = bloque.querySelector('[data-nk-variante-id]');
      var elPrecio = bloque.querySelector('[data-nk-precio]');
      var elComp = bloque.querySelector('[data-nk-precio-comp]');
      var btnAnadir = bloque.querySelector('[data-nk-anadir]');
      var textos = {
        anadir: bloque.getAttribute('data-texto-anadir') || 'Add to cart',
        agotado: bloque.getAttribute('data-texto-agotado') || 'Sold out'
      };
      var grupos = bloque.querySelectorAll('[data-nk-opcion]');
      var principal = bloque.querySelector('[data-nk-galeria-principal]');

      function seleccionActual() {
        var sel = [];
        grupos.forEach(function (grupo) {
          var activo = grupo.querySelector('.nk-opcion__btn.nk-activa');
          sel.push(activo ? activo.getAttribute('data-valor') : null);
        });
        return sel;
      }

      function buscarVariante(sel) {
        for (var i = 0; i < variantes.length; i++) {
          var v = variantes[i];
          var coincide = true;
          for (var j = 0; j < sel.length; j++) {
            if (sel[j] !== null && v.options[j] !== sel[j]) {
              coincide = false;
              break;
            }
          }
          if (coincide) return v;
        }
        return null;
      }

      function pintar() {
        var v = buscarVariante(seleccionActual());
        if (!v) return;

        if (inputId) inputId.value = v.id;
        if (elPrecio) elPrecio.textContent = v.precio;

        if (elComp) {
          if (v.comp) {
            elComp.textContent = v.comp;
            elComp.style.display = '';
          } else {
            elComp.style.display = 'none';
          }
        }

        if (btnAnadir) {
          btnAnadir.disabled = !v.disponible;
          btnAnadir.textContent = v.disponible ? textos.anadir : textos.agotado;
        }

        if (v.imagen && principal) {
          principal.src = v.imagen;
        }

        grupos.forEach(function (grupo) {
          var etiqueta = grupo.querySelector('[data-nk-opcion-valor]');
          var activo = grupo.querySelector('.nk-opcion__btn.nk-activa');
          if (etiqueta && activo) etiqueta.textContent = activo.textContent.trim();
        });
      }

      grupos.forEach(function (grupo) {
        grupo.querySelectorAll('.nk-opcion__btn').forEach(function (btn) {
          btn.addEventListener('click', function () {
            grupo.querySelectorAll('.nk-opcion__btn').forEach(function (b) {
              b.classList.remove('nk-activa');
            });
            btn.classList.add('nk-activa');
            pintar();
          });
        });
      });

      pintar();
    });
  }

  /* ----------------------------------------------------------------------
     Selector de cantidad
     ---------------------------------------------------------------------- */
  function initCantidad(root) {
    var cajas = (root || document).querySelectorAll('[data-nk-cantidad]');
    if (!cajas.length) return;

    cajas.forEach(function (caja) {
      if (caja.dataset.nkListo === '1') return;
      caja.dataset.nkListo = '1';

      var input = caja.querySelector('input');
      var menos = caja.querySelector('[data-nk-menos]');
      var mas = caja.querySelector('[data-nk-mas]');
      if (!input) return;

      function ajusta(delta) {
        var v = parseInt(input.value, 10);
        if (isNaN(v)) v = 1;
        v = Math.max(1, Math.min(99, v + delta));
        input.value = v;
      }

      if (menos) menos.addEventListener('click', function () { ajusta(-1); });
      if (mas) mas.addEventListener('click', function () { ajusta(1); });

      input.addEventListener('change', function () {
        var v = parseInt(input.value, 10);
        if (isNaN(v) || v < 1) input.value = 1;
        if (v > 99) input.value = 99;
      });
    });
  }

  /* ----------------------------------------------------------------------
     Marquesina: duplica el contenido para que el bucle no tenga costura
     ---------------------------------------------------------------------- */
  function initMarquesina(root) {
    var pistas = (root || document).querySelectorAll('[data-nk-marquesina]');
    if (!pistas.length) return;

    pistas.forEach(function (pista) {
      if (pista.dataset.nkListo === '1') return;
      pista.dataset.nkListo = '1';

      var hijos = Array.prototype.slice.call(pista.children);
      hijos.forEach(function (hijo) {
        var copia = hijo.cloneNode(true);
        copia.setAttribute('aria-hidden', 'true');
        pista.appendChild(copia);
      });
    });
  }

  /* ----------------------------------------------------------------------
     Acordeón FAQ: solo uno abierto a la vez
     ---------------------------------------------------------------------- */
  function initFaq(root) {
    var listas = (root || document).querySelectorAll('[data-nk-faq]');
    if (!listas.length) return;

    listas.forEach(function (lista) {
      if (lista.dataset.nkListo === '1') return;
      lista.dataset.nkListo = '1';

      var items = lista.querySelectorAll('details');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (otro) {
            if (otro !== item) otro.open = false;
          });
        });
      });
    });
  }

  /* ----------------------------------------------------------------------
     Fecha de entrega estimada

     En vez de "10-18 días" se enseña un día concreto del calendario, que es
     mucho más fácil de juzgar para quien compra. El rango viene del metacampo
     del producto, así que cambiarlo no toca código.
     ---------------------------------------------------------------------- */
  function initEntrega(root) {
    var marcas = (root || document).querySelectorAll('[data-nk-entrega]');
    if (!marcas.length) return;

    marcas.forEach(function (el) {
      if (el.dataset.nkListo === '1') return;
      el.dataset.nkListo = '1';

      var partes = (el.getAttribute('data-nk-entrega') || '').split('-');
      var min = parseInt(partes[0], 10);
      var max = parseInt(partes[1], 10);
      if (isNaN(min) || isNaN(max)) return;

      function fecha(dias) {
        var d = new Date();
        d.setDate(d.getDate() + dias);
        return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
      }

      el.textContent = fecha(min) + ' – ' + fecha(max);
    });
  }

  /* ----------------------------------------------------------------------
     Vídeos verticales: play/pausa al pulsar
     ---------------------------------------------------------------------- */
  function initClips(root) {
    var clips = (root || document).querySelectorAll('.nk-clip');
    if (!clips.length) return;

    clips.forEach(function (clip) {
      if (clip.dataset.nkListo === '1') return;
      clip.dataset.nkListo = '1';

      var video = clip.querySelector('video');
      var boton = clip.querySelector('[data-nk-play]');
      if (!video) return;

      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');

      function alterna(e) {
        if (e) e.preventDefault();
        if (video.paused) {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
          if (boton) boton.setAttribute('aria-label', 'Pause video');
        } else {
          video.pause();
          if (boton) boton.setAttribute('aria-label', 'Play video');
        }
      }

      if (boton) boton.addEventListener('click', alterna);

      /* En escritorio, previsualiza al pasar el ratón (como en TikTok web) */
      if (!reduceMotion && window.matchMedia('(hover: hover)').matches) {
        clip.addEventListener('mouseenter', function () {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        });
        clip.addEventListener('mouseleave', function () {
          video.pause();
          video.currentTime = 0;
        });
      }
    });
  }

  /* ----------------------------------------------------------------------
     Carrusel de la portada

     El movimiento de verdad lo hace el CSS (scroll con anclajes), así que
     aquí solo hay: pase automático, flechas, puntitos y las pausas.

     Se pausa cuando el ratón está encima, cuando el foco del teclado está
     dentro, cuando la pestaña no se ve y mientras el dedo arrastra. Un
     carrusel que sigue pasando mientras alguien lee es de las cosas que más
     molestan de una web.
     ---------------------------------------------------------------------- */
  function initCarrusel(root) {
    var carruseles = (root || document).querySelectorAll('[data-nk-carrusel]');

    carruseles.forEach(function (car) {
      if (car.__nkListo) return;
      car.__nkListo = true;

      var pista = car.querySelector('[data-nk-pista]');
      if (!pista) return;

      var diapos = pista.querySelectorAll('[data-nk-diapo]');
      if (diapos.length < 2) return;

      var puntos = [].slice.call(car.querySelectorAll('[data-nk-punto]'));
      var btnAnterior = car.querySelector('[data-nk-anterior]');
      var btnSiguiente = car.querySelector('[data-nk-siguiente]');
      var auto = car.getAttribute('data-auto') === '1' && !reduceMotion;
      var espera = (parseInt(car.getAttribute('data-segundos'), 10) || 6) * 1000;
      var reloj = null;
      var pendiente = false;

      function cual() {
        if (!pista.clientWidth) return 0;
        return Math.round(pista.scrollLeft / pista.clientWidth);
      }

      function irA(i) {
        var n = diapos.length;
        i = ((i % n) + n) % n; // da la vuelta en los dos sentidos
        var destino = i * pista.clientWidth;

        pista.scrollTo({
          left: destino,
          behavior: reduceMotion ? 'auto' : 'smooth'
        });

        /* El punto se marca YA, sin esperar a que termine el desplazamiento.
           Si se dejara solo en manos del evento de scroll, el punto tardaría
           en encenderse lo que dura la animación y parecería que el clic no
           ha hecho nada. */
        pintarPuntos(i);

        /* Red de seguridad: el desplazamiento suave lo mueve el navegador
           cuadro a cuadro, y hay situaciones en las que esos cuadros no
           llegan (pestaña en segundo plano, navegador ahorrando batería).
           Si pasado medio segundo no ha llegado, se coloca de golpe. Sin
           esto los puntitos dirían una foto y se estaría viendo otra. */
        clearTimeout(car.__nkRed);
        car.__nkRed = setTimeout(function () {
          if (Math.abs(pista.scrollLeft - destino) > 4) {
            pista.scrollLeft = destino;
          }
        }, 550);
      }

      function pintarPuntos(forzado) {
        var i = typeof forzado === 'number' ? forzado : cual();
        puntos.forEach(function (p, j) {
          p.classList.toggle('nk-activo', j === i);
          if (j === i) {
            p.setAttribute('aria-current', 'true');
          } else {
            p.removeAttribute('aria-current');
          }
        });
      }

      function arrancar() {
        if (!auto || reloj) return;
        reloj = setInterval(function () { irA(cual() + 1); }, espera);
      }

      function parar() {
        if (reloj) { clearInterval(reloj); reloj = null; }
      }

      /* Tras tocar una flecha o un punto se reinicia la cuenta: si no, la
         siguiente foto puede saltar medio segundo después. */
      function reiniciar() { parar(); arrancar(); }

      pista.addEventListener('scroll', function () {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(function () {
          pendiente = false;
          pintarPuntos();
        });
      }, { passive: true });

      if (btnAnterior) {
        btnAnterior.addEventListener('click', function () { irA(cual() - 1); reiniciar(); });
      }
      if (btnSiguiente) {
        btnSiguiente.addEventListener('click', function () { irA(cual() + 1); reiniciar(); });
      }
      puntos.forEach(function (p) {
        p.addEventListener('click', function () {
          irA(parseInt(p.getAttribute('data-nk-punto'), 10) || 0);
          reiniciar();
        });
      });

      car.addEventListener('mouseenter', parar);
      car.addEventListener('mouseleave', arrancar);
      car.addEventListener('focusin', parar);
      car.addEventListener('focusout', function (e) {
        if (!car.contains(e.relatedTarget)) arrancar();
      });
      car.addEventListener('pointerdown', parar, { passive: true });
      car.addEventListener('pointerup', arrancar, { passive: true });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { parar(); } else { arrancar(); }
      });

      /* Al cambiar el ancho de la ventana, la posición guardada deja de
         cuadrar con la diapositiva: se recoloca sin animación. */
      var anchoPrevio = pista.clientWidth;
      window.addEventListener('resize', function () {
        if (pista.clientWidth === anchoPrevio) return;
        var i = Math.round(pista.scrollLeft / anchoPrevio);
        anchoPrevio = pista.clientWidth;
        pista.scrollTo({ left: i * pista.clientWidth, behavior: 'auto' });
      });

      /* Las fotos que no son la primera vienen con carga diferida para que la
         portada aparezca rápido. Pero la carga diferida del navegador mira si
         el elemento entra en la pantalla VERTICALMENTE: dentro de un carril
         que se desplaza en horizontal muchas veces no se dispara nunca, y la
         diapositiva sale en blanco. Así que, en cuanto la página ha terminado
         de cargar y ya no molesta, se piden a mano. */
      function cargarElResto() {
        var fotos = pista.querySelectorAll('img[loading="lazy"]');
        Array.prototype.forEach.call(fotos, function (img) {
          img.loading = 'eager';
          if (img.dataset.nkSrc) img.src = img.dataset.nkSrc;
        });
      }
      if (document.readyState === 'complete') {
        setTimeout(cargarElResto, 200);
      } else {
        window.addEventListener('load', function () { setTimeout(cargarElResto, 200); });
      }

      pintarPuntos();
      arrancar();
    });
  }

  /* ----------------------------------------------------------------------
     Ventana de bienvenida

     Lo delicado de un pop-up no es enseñarlo, es no volverse pesado y no
     dejar tirada a la gente que navega con teclado. Por eso: recuerda que se
     cerró, se cierra con Escape y con clic fuera, el tabulador no se escapa
     mientras está abierta, y al cerrarla el foco vuelve donde estaba.
     ---------------------------------------------------------------------- */
  function initPopup(root) {
    var popups = (root || document).querySelectorAll('[data-nk-popup]');

    popups.forEach(function (pop) {
      if (pop.__nkListo) return;
      pop.__nkListo = true;

      var caja = pop.querySelector('.nk-popup__caja');
      var llave = pop.getAttribute('data-llave') || 'nk-popup';
      var espera = (parseInt(pop.getAttribute('data-espera'), 10) || 0) * 1000;
      var dias = parseInt(pop.getAttribute('data-dias'), 10) || 14;
      var enEditor = pop.getAttribute('data-editor') === '1';
      var focoPrevio = null;
      var reloj = null;

      function guardado() {
        try {
          var v = localStorage.getItem(llave);
          if (!v) return false;
          return Date.now() < parseInt(v, 10);
        } catch (e) {
          /* Navegación privada o cookies bloqueadas: no se recuerda, pero
             tampoco se rompe nada. */
          return false;
        }
      }

      function recordar() {
        try {
          localStorage.setItem(llave, String(Date.now() + dias * 86400000));
        } catch (e) {}
      }

      function enfocables() {
        return caja.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
        );
      }

      function alTeclado(e) {
        if (e.key === 'Escape') { cerrar(); return; }
        if (e.key !== 'Tab') return;
        var f = enfocables();
        if (!f.length) return;
        var primero = f[0], ultimo = f[f.length - 1];
        if (e.shiftKey && document.activeElement === primero) {
          e.preventDefault(); ultimo.focus();
        } else if (!e.shiftKey && document.activeElement === ultimo) {
          e.preventDefault(); primero.focus();
        }
      }

      function abrir() {
        if (!pop.hidden) return;
        focoPrevio = document.activeElement;
        pop.hidden = false;
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', alTeclado);
        var f = enfocables();
        if (f.length) f[0].focus();
      }

      function cerrar() {
        if (pop.hidden) return;
        pop.hidden = true;
        document.body.style.overflow = '';
        document.removeEventListener('keydown', alTeclado);
        recordar();
        if (focoPrevio && focoPrevio.focus) focoPrevio.focus();
      }

      pop.querySelectorAll('[data-nk-popup-cerrar]').forEach(function (b) {
        b.addEventListener('click', cerrar);
      });
      var fuera = pop.querySelector('[data-nk-popup-fuera]');
      if (fuera) fuera.addEventListener('click', cerrar);

      /* En el editor sale siempre y al momento, para poder ajustarla. */
      if (enEditor) { abrir(); return; }

      /* Si el formulario acaba de enviarse, la página se recarga con el
         mensaje de gracias: hay que enseñarla para que se lea. */
      if (pop.querySelector('.nk-popup__gracias')) { abrir(); return; }

      if (guardado()) return;
      reloj = setTimeout(abrir, espera);

      /* Si alguien se va de la página antes de tiempo, que no salte al volver */
      window.addEventListener('pagehide', function () { clearTimeout(reloj); });
    });
  }

  /* ----------------------------------------------------------------------
     Arranque
     ---------------------------------------------------------------------- */
  /* ----------------------------------------------------------------------
     Fotos de la descripción: de columna interminable a rejilla

     EL PROBLEMA: las descripciones importadas de AutoDS traen diez o doce
     fotos del proveedor, cada una a todo el ancho y una debajo de otra. En un
     producto medido: 11 fotos, 7.824 px de alto, el 62% de la página entera,
     con 22 palabras de texto entre ellas. Nadie baja catorce pantallas.

     QUÉ HACE: saca esas fotos de donde están y las recoloca en una rejilla
     compacta al final del bloque. Las mismas fotos, en 800 px en vez de 7.800.
     Al pulsar una se abre a tamaño grande.

     Por qué en JavaScript y no en CSS: el HTML de la descripción viene del
     proveedor y no hay dos iguales — unas veces las fotos van sueltas, otras
     dentro de párrafos o tablas. Recolocarlas es más fiable que intentar
     adivinar su envoltorio con selectores.
     ---------------------------------------------------------------------- */
  function initFotosDescripcion(root) {
    var bloques = (root || document).querySelectorAll('[data-nk-detalle]');

    bloques.forEach(function (bloque) {
      if (bloque.__nkListo) return;
      bloque.__nkListo = true;

      var desc = bloque.querySelector('.nk-producto__descripcion');
      if (!desc) return;

      var minimo = parseInt(bloque.getAttribute('data-minimo'), 10) || 3;
      var fotos = [].slice.call(desc.querySelectorAll('img'));
      if (fotos.length < minimo) return; // con dos o tres, dejarlas donde están

      var rejilla = document.createElement('div');
      rejilla.className = 'nk-detalle-fotos';

      fotos.forEach(function (img) {
        var boton = document.createElement('button');
        boton.type = 'button';
        boton.className = 'nk-detalle-foto';
        boton.setAttribute('aria-label', bloque.getAttribute('data-texto-ampliar') || 'Enlarge photo');

        var copia = new Image();
        copia.src = img.currentSrc || img.src;
        copia.alt = '';
        copia.loading = 'lazy';
        boton.appendChild(copia);
        rejilla.appendChild(boton);

        /* Se quita la foto de su sitio original. Si su envoltorio se queda
           vacío (un <p> que solo tenía la imagen), se quita también para no
           dejar huecos sueltos. */
        var padre = img.parentNode;
        padre.removeChild(img);
        while (padre && padre !== desc && !padre.textContent.trim() && !padre.querySelector('img')) {
          var abuelo = padre.parentNode;
          abuelo.removeChild(padre);
          padre = abuelo;
        }
      });

      desc.appendChild(rejilla);

      /* VISOR GRANDE, con flechas para recorrer todas las fotos.
         Abrir una imagen y quedarse encerrado en ella obliga a cerrar y volver
         a abrir once veces. Aquí se pasa de una a otra sin salir. */
      var fuentes = [].map.call(rejilla.querySelectorAll('img'), function (i) { return i.src; });
      var actual = 0;

      var textoAnterior = bloque.getAttribute('data-texto-anterior') || 'Previous photo';
      var textoSiguiente = bloque.getAttribute('data-texto-siguiente') || 'Next photo';

      var visor = document.createElement('div');
      visor.className = 'nk-visor';
      visor.setAttribute('hidden', '');
      visor.setAttribute('role', 'dialog');
      visor.setAttribute('aria-modal', 'true');
      visor.innerHTML =
        '<button type="button" class="nk-visor__cerrar" aria-label="' +
          (bloque.getAttribute('data-texto-cerrar') || 'Close') + '">&times;</button>' +
        '<button type="button" class="nk-visor__flecha nk-visor__flecha--izq" aria-label="' + textoAnterior + '">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg></button>' +
        '<img alt="">' +
        '<button type="button" class="nk-visor__flecha nk-visor__flecha--der" aria-label="' + textoSiguiente + '">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg></button>' +
        '<span class="nk-visor__cuenta"></span>';
      document.body.appendChild(visor);

      var imgVisor = visor.querySelector('img');
      var cuenta = visor.querySelector('.nk-visor__cuenta');
      var flechas = visor.querySelectorAll('.nk-visor__flecha');

      function pintar() {
        imgVisor.src = fuentes[actual];
        cuenta.textContent = (actual + 1) + ' / ' + fuentes.length;
        /* Con una sola foto las flechas sobran. */
        [].forEach.call(flechas, function (f) { f.hidden = fuentes.length < 2; });
        cuenta.hidden = fuentes.length < 2;
      }
      function mover(paso) {
        actual = (actual + paso + fuentes.length) % fuentes.length;  // da la vuelta
        pintar();
      }
      function abrir(i) {
        actual = i;
        pintar();
        visor.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
        visor.querySelector('.nk-visor__cerrar').focus();
      }
      function cerrar() {
        visor.setAttribute('hidden', '');
        imgVisor.src = '';
        document.body.style.overflow = '';
      }

      rejilla.addEventListener('click', function (e) {
        var b = e.target.closest('.nk-detalle-foto');
        if (b) abrir([].indexOf.call(rejilla.children, b));
      });

      visor.addEventListener('click', function (e) {
        /* Solo cierra al pulsar el fondo: sobre la foto o las flechas, no. */
        if (e.target.closest('.nk-visor__flecha')) {
          mover(e.target.closest('.nk-visor__flecha--der') ? 1 : -1);
          return;
        }
        if (e.target === imgVisor) return;
        cerrar();
      });

      document.addEventListener('keydown', function (e) {
        if (visor.hasAttribute('hidden')) return;
        if (e.key === 'Escape') cerrar();
        else if (e.key === 'ArrowRight') mover(1);
        else if (e.key === 'ArrowLeft') mover(-1);
      });

      /* Deslizar con el dedo en el móvil, donde no hay teclas. */
      var x0 = null;
      visor.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      visor.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 50) mover(dx < 0 ? 1 : -1);
        x0 = null;
      }, { passive: true });
    });
  }

  function initTodo(root) {
    initReveals(root);
    initGaleria(root);
    initVariantes(root);
    initCantidad(root);
    initMarquesina(root);
    initFaq(root);
    initEntrega(root);
    initClips(root);
    initCarrusel(root);
    initPopup(root);
    initFotosDescripcion(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTodo(document); });
  } else {
    initTodo(document);
  }

  /* El editor de Shopify recarga secciones sueltas: re-inicializa esa sección */
  document.addEventListener('shopify:section:load', function (e) {
    initTodo(e.target);
  });
})();
